export const validation = {
  headingMaxChar: 100,
  paragraphMaxChar: 200,
  contactMaxChar: 100
}

export const EMPTY_FIELD_MESSAGE = 'This field cannot be empty'
export const INVALID_EMAIL_MESSAGE = 'Please enter a valid email'
